import { createContext, useMemo } from "react";
import I18n, { DEFAULT_LOCALE } from "../locales";

export const LocaleContext = createContext(new I18n(DEFAULT_LOCALE));

export function LocalizationWrapper({ locale, children }) {
  const i18n = useMemo(() => new I18n(locale), [locale]);

  return (
    <LocaleContext.Provider value={i18n}>{children}</LocaleContext.Provider>
  );
}
